
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1","y":"1","width":"38","height":"38","rx":"5","fill":"#212A4B"}}),_c('path',{attrs:{"d":"M23.75 13.75L26.25 16.25L24.25 18.25L21.75 15.75L23.75 13.75Z","fill":"white"}}),_c('path',{attrs:{"d":"M20.75 16.75L23.25 19.25L16.25 26.25H13.75L13.75 23.75L20.75 16.75Z","fill":"white"}}),_c('rect',{attrs:{"x":"1","y":"1","width":"38","height":"38","rx":"5","stroke":"#2A355D","stroke-width":"2"}})])
          )
        }
      }
    